<template>
  <div class="typed-on-paper-tabs-padding">

    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'CommunicationsSetup'}">
      <div class="heading">Set up Comms</div>
    </DivLinkButton>

    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'CampaignSkins'}">
      <div class="heading">Get Campaign Skins</div>
    </DivLinkButton>

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">After Action Reports</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">How to write an AAR</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'HowToAAR'}">-->
<!--      <div class="heading">How to submit Claims</div>-->
<!--    </DivLinkButton>-->


  </div>
</template>

<script>
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"

export default {
  name: "ProceduresInfoSideNav",
  components: {
    DivLinkButton,
    HideableDiv
  },
  methods: {

    navigate_to: function (link) {

      location.replace(link);
    }
  }

}
</script>

<style scoped>

.subcontent-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 15px;
  width: calc(100% - 15px - 26px);
}

</style>



// WEBPACK FOOTER //
// src/components/info/ProceduresInfoSideNav.vue